import { FailureCircleIcon } from "@gadgetinc/widgets/src/icons/FailureCircleIcon";
import { SuccessCircleIcon } from "@gadgetinc/widgets/src/icons/SuccessCircleIcon";
import { WarningIcon } from "@gadgetinc/widgets/src/icons/WarningIcon";
import { useStyletron } from "baseui";
import React from "react";

export const LintSnippetTitle = (props: { type?: "success" | "warning" | "error"; children: React.ReactNode }) => {
  const [_css, $theme] = useStyletron();

  return (
    <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      {props.type &&
        (props.type === "success" ? (
          <SuccessCircleIcon color={$theme.colors.green300} />
        ) : props.type === "warning" ? (
          <WarningIcon color={$theme.colors.yellow300} />
        ) : (
          <FailureCircleIcon color={$theme.colors.red300} />
        ))}
      {props.children}
    </span>
  );
};
